import React from "react";
import { Text, TouchableHighlight, TouchableOpacity, View } from "react-native";
import { useTooltips } from "../../../context/WalkthroughContext";
import Tooltip from "react-native-walkthrough-tooltip";
import { AppColors } from "../../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import ImageComponent from "../../ImageComponent";
import { AppImages } from "../../../utility/AppImages";
import { CropImage } from "../../choose-avatar-components/CropImage";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import Avatar from "../../choose-avatar-components/Avatar";

const EventNameWalkthrough = () => {
  const {
    eventNameTooltipVisible,
    setEventNameTooltipVisible,
    setDeviceTooltipVisible,
    currentStep,
    totalSteps,
    handleNextStep,
  } = useTooltips();

  const deviceSize = useDeviceSize();

  return (
    <View style={{ alignItems: "flex-start" }}>
      <Tooltip
        isVisible={eventNameTooltipVisible}
        contentStyle={{
          backgroundColor: AppColors.purple_453B50,
          width: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 736 : 350,
          borderColor: AppColors.white,
          shadowColor: "rgba(255, 255, 255, 0.65)",
          shadowOffset: { width: 0, height: 0 },
          shadowOpacity: 0.65,
          shadowRadius: 10.1,
          elevation: 5,
          borderWidth: 1,
          height: "auto",
        }}
        displayInsets={{
          top: 0,
          bottom: 0,
          left: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 300 : 10,
          right: 0,
        }}
        arrowStyle={{
          display: "none",
        }}
        content={
          <View>
            <View
              style={{
                flexDirection:
                  deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                    ? "row"
                    : "column",
                gap: 10,
              }}
            >
              {" "}
              <TouchableOpacity
                onPress={() => {
                  setEventNameTooltipVisible(false);
                }}
                style={{ position: "absolute", right: 0, top: 0, zIndex: 1 }}
              >
                <ImageComponent
                  url={AppImages.icCloseWhiteSvg}
                  style={{
                    height: 16,
                    width: 16,
                    resizeMode: "contain",
                  }}
                />
              </TouchableOpacity>{" "}
              <View
                style={{
                  flexDirection: "row",
                  gap: 10,
                  alignItems: "center",
                }}
              >
                <Avatar
                  src="https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                  variant="walkthroughPlayer"
                />
                {deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ? (
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      { color: AppColors.white }, // Set text color for better readability
                    ]}
                  >
                    Choose a Name for Your Event 🏷️
                  </Text>
                ) : null}
              </View>
              <View
                style={{
                  flex: 1,
                  marginTop:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 0
                      : 12,
                }}
              >
                <View style={{ gap: 10 }}>
                  {deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ? null : (
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_16,
                        { color: AppColors.white },
                      ]}
                    >
                      Choose a Name for Your Event 🏷️
                    </Text>
                  )}
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { lineHeight: 21 },
                    ]}
                  >
                    Give your event a memorable name to make it stand out and
                    grab attention from viewers and potential challengers.
                  </Text>
                </View>
              </View>
            </View>{" "}
            <View
              style={{
                gap: 10,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
                marginTop: 10,
              }}
            >
              <Text
                style={{
                  ...AppFontStyle.REGULAR_ANYBODY_12,
                  color: AppColors.green_00FFE8,
                }}
              >
                {currentStep + 1} / {totalSteps}
              </Text>
              <TouchableOpacity
                onPress={() => {
                  setEventNameTooltipVisible(false);
                  setDeviceTooltipVisible(true);
                  handleNextStep();
                }}
                style={{
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  width: 70,
                  height: 20,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 10,
                }}
              >
                <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
              </TouchableOpacity>
            </View>
          </View>
        }
        placement={deviceSize === DEVICE_SIZES.XL ? "top" : "bottom"}
      >
        <TouchableHighlight>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_12,
              {
                paddingTop: 0,
              },
            ]}
          >
            Event name
          </Text>
        </TouchableHighlight>
      </Tooltip>
    </View>
  );
};

export default EventNameWalkthrough;
